import { instanceToPlain, plainToInstance } from 'class-transformer';
import { httpsCallable } from 'firebase/functions';
import AcceptanceTerm from '../../entities/acceptance-term.entity';
import { functions } from '../../utils/firebase.config';

type FetchAllResponse = AcceptanceTerm[];

export const useTerms = () => {
  const fetchAll = async (): Promise<AcceptanceTerm[]> => {
    const callable = httpsCallable<void, FetchAllResponse>(functions, 'fetchAllTerms');

    const result = await callable();

    return result.data.map((term) => plainToInstance(AcceptanceTerm, term));
  };

  const insert = async (input: Omit<AcceptanceTerm, 'id'>) => {
    const callable = httpsCallable<Record<string, unknown>, void>(functions, 'insertAcceptanceTerm');

    const resource = instanceToPlain(new AcceptanceTerm(input));

    await callable(resource);
  };

  return { fetchAll, insert };
};

export default useTerms;
